import { cn } from '@/lib/cn';

/** Placeholder block. Decorative: hidden from assistive tech. */
export function Skeleton({ className }: { className?: string }) {
  return <div aria-hidden className={cn('animate-pulse rounded-md bg-surface-3', className)} />;
}
